/* tslint:disable:no-console */
export default {
	log: console.log,
	table: console.table,
};
